/**
 * Convierte un string en un slug amigable para URLs.
 * Remueve acentos, espacios, y caracteres especiales.
 * @param {string} text 
 * @returns {string}
 */
export const generateSlug = (text) => {
    if (!text) return "";
    return text
        .toString()
        .toLowerCase()
        .trim()
        .normalize('NFD')                   // Descompone caracteres con acentos
        .replace(/[\u0300-\u036f]/g, '')   // Remueve marcas de acento
        .replace(/[^a-z0-9 -]/g, '')       // Remueve caracteres inválidos (solo letras, números, espacios y guiones)
        .replace(/\s+/g, '-')              // Reemplaza espacios por guiones
        .replace(/-+/g, '-');              // Colapsa múltiples guiones
};

/**
 * Compara dos textos comprobando si sus slugs coinciden.
 * @param {string} text1 
 * @param {string} text2 
 * @returns {boolean}
 */
export const compareBySlug = (text1, text2) => {
    return generateSlug(text1) === generateSlug(text2);
};
